import { render, staticRenderFns } from "./DigitalRecordDownload.vue?vue&type=template&id=13145406"
import script from "./DigitalRecordDownload.vue?vue&type=script&lang=js"
export * from "./DigitalRecordDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports